import React, { useEffect, useState, useMemo } from "react";
import { Button, Form, message, Modal, Spin, Switch, Tooltip } from "antd";
import styled from "styled-components";
import { Row, Col, Input, Avatar, Badge } from "antd";
import { Select } from "antd";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Mention } from "quill-mention";
import "quill-mention/dist/quill.mention.css";
import { ReactComponent as Active } from "../../assets/images/Group 1000004608 (1).svg";
import {
  CloseOutlined,
  FilterOutlined,
  SearchOutlined,
} from "@ant-design/icons";
// import { ReactComponent as EditIcon } from "../../Reusablecomponents/Icons/edit.svg";
// import { ReactComponent as DeleteIcon } from "../../Reusablecomponents/Icons/delete.svg";
import ReusableDrawer from "../../Reusablecomponents/ReusableDrawer";
import { StyledTable } from "../../Reusablecomponents/UITable/UITable";
import GridBuilder from "../../UIBuilderEngine/GridBuilder";
import { useNavigate } from "react-router-dom";
import KpiCustfied from "./Kpimaster/KpiCustfied";
import { CALL_API } from "../../Common/api";
import { useSelector } from "react-redux";
import {
  ActiontypeEnum,
  EventType,
  Reciepenttype,
  RTypeEnum,
  CustomTagsEnum,
  AIConsignmentDeliveryEvents,
  ContainerConsignmentEventsForCustom,
} from "../../Common/constant";
import { UIModal } from "../../Reusablecomponents/UIModal";
import deleteicon from "../../assets/images/delete-3-svgrepo-com.svg";
import edit from "../../assets/images/edit-1-svgrepo-com.svg";
import {
  ButtonFilled,
  Buttontransparent,
} from "../../Reusablecomponents/UIButtons";
import ReusablePagination from "../../Reusablecomponents/ReusablePagination";
import { AutoComplete } from "antd";

Quill.register("modules/mention", Mention);

const { Option } = Select;

const Newbox = styled.div`
  p {
    margin: 0px 0px 0px 0px;
    line-height: 0px;
    color: rgb(95, 109, 140);
  }
  .search_icon {
    color: rgb(95, 109, 140);
    font-size: 18px;
  }
  .container_for_kpi {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .container_for_kp {
    display: flex;
    align-items: center;
    gap: 25px;
    margin: 0px 0px 0px 0px;
  }
  .container_for_kp_popup {
    display: flex;
    align-items: center;
    gap: 25px;
    margin: 20px 0px 0px 0px;
    border-top: 1px solid rgb(231, 231, 237);
  }
  .container_for_kpi_filter {
    display: flex;
    justify-content: space-between;
    padding-right: 40px;
    margin: 0px 0px 30px 0px;
  }

  .ant-select .ant-select-selector {
    border-radius: 18px;
  }
  .ant-avatar-square {
    border-radius: 50% !important;
    cursor: pointer;
    background-color: rgb(220, 237, 223);
    padding: 20px 20px 20px 20px;
  }
  .Filter_for_clickablerow {
    font-size: 18px !important;
    font-weight: 600 !important;
  }
  .Filter_for_Result {
    font-size: 18px;
    color: rgb(44, 150, 61);
  }
  .select_label {
    color: rgb(95, 109, 140);
    margin-bottom: 5px;
  }
  .select_container {
    display: flex;
    flex-direction: column;
    margin: 30px 0px 0px 0px;
  }
  .and_clear_btn.ant-btn {
    padding: 9px 24px !important;
    color: white !important;
    background-color: rgb(44, 150, 61) !important;
    border-radius: 19px !important;
    border: none !important;
    font-size: 17px;
  }
  .table_forkpi_page {
    margin: 30px 0px;
  }
  .popup_container_for_forms {
    display: flex;
    justify-content: space-between;
    margin-bottom: 40px;
  }
  .modifying_kpi {
    border-top: 1px solid rgb(231, 231, 237);
    font-family: Inter;
    font-weight: 500;
    font-style: Medium;
    font-size: 20px;
    line-height: 100%;
    letter-spacing: 0%;
  }
`;

const Kpimaster = () => {
  const [formData, setFormData] = useState({
    kpiname: "",
    eventtype: "",
    Action: "",
    recipiententitytype: "",
    Additionalrecipient: "",
    Minuteslessthan: "",
    Minutesexceed: "",
    Vehicletype: "",
    InfoOnly: false,
    Autorepeated: false,
    message: "",
    ModuleType: "",
  });
  const [form] = Form.useForm();
  const [filterform] = Form.useForm();
  const vehicleType = useSelector((state) => state?.authTracking?.vehicleType);

  const [isModalOpeN, setIsModalOpeN] = useState(false);
  const [hoveredIcon, setHoveredIcon] = useState(null);
  const [Drawyeropen, setDrawyeropen] = useState(false);
  const [stateforpage, setStateforpage] = useState(false);
  const [isView, setIsView] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [filterCount, setFilterCount] = useState(0);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [filterValues, setFilterValues] = useState({
    actiontype: "",
    eventtype: "",
    name: "",
  });
  const [kpiData, setKpiData] = useState([]);
  const navigate = useNavigate();
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const respientList = useSelector(
    (state) => state?.authTracking?.respientList,
  );
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const createAllowed = useMemo(
    () => hasPermission("KPI", "C"),
    [reduxPermissions],
  );
  const updateAllowed = useMemo(
    () => hasPermission("KPI", "U"),
    [reduxPermissions],
  );
  const deleteAllowed = useMemo(
    () => hasPermission("KPI", "D"),
    [reduxPermissions],
  );
  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const handlePageSizeChange = (value) => {
    setPageSize(value);
    setCurrentPage(1);
  };

  const fetchKpiData = async () => {
    setLoading(true);
    const { data } = await CALL_API(
      "GET",
      `kpi/getAll?name=${filterValues?.name || ""}&evType=${
        filterValues?.eventtype
      }&action=${
        filterValues?.actiontype
      }&limit=${pageSize}&page=${currentPage}`,
      {},
    );
    setKpiData(data?.data);
    setTotal(data?.totalRecords);
    setLoading(false);
  };

  const showModal = () => {
    setFilterModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpeN(false);
  };

  const handleCancel_btn = () => {
    setIsModalOpeN(false);
  };

  const handleCancel = () => {
    form.resetFields();
    setFormData({
      kpiname: "",
      eventtype: "",
      Action: "",
      recipiententitytype: "",
      Additionalrecipient: "",
      Minuteslessthan: "",
      Minutesexceed: "",
      Vehicletype: "",
      InfoOnly: false,
      Autorepeated: false,
      ModuleType: "",
      message: "",
    });
    setIsEdit(false);
    setDrawyeropen(false);
  };

  const handleSelectChange = (value, name) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    // Reset dependent fields when Action changes
    if (name === "Action") {
      setFormData((prevData) => ({
        ...prevData,
        Additionalrecipient: "",
        message: "",
      }));
      // Also reset the form field
      form.setFieldsValue({
        Additionalrecipient: "",
        message: "",
      });
    }
  };

  const handleRowClick = (record) => {
    setStateforpage(record);
    setIsView(true);
  };

  const columns = [
    {
      title: "KPI Name",
      dataIndex: "NAME",
      key: "NAME",
    },
    {
      title: "Event Type",
      dataIndex: "EVTYPE",
      key: "EVTYPE",
      render: (text) => {
        const data = RTypeEnum.find((val) => val?.value === text);
        return data ? data.name : "-";
      },
    },
    {
      title: "Action",
      dataIndex: "ACTION",
      key: "ACTION",
      render: (text) => {
        const data = ActiontypeEnum.find((val) => val?.value === text);
        return data ? data.name : "-";
      },
    },
    {
      title: "Module",
      dataIndex: "ModuleType",
      key: "ModuleType",
      render: (text) => {
        const data = modulelabel.find((val) => val?.value === text);
        return data ? data.name : "-";
      },
    },
    {
      title: "Minutes Less than",
      dataIndex: "MINMINUTES",
      key: "MINMINUTES",
      render: (text) => {
        return text ? text : "-";
      },
    },
    {
      title: "Minutes Exceed",
      dataIndex: "MAXMINUTES",
      key: "MAXMINUTES",
      render: (text) => {
        return text ? text : "-";
      },
    },
    {
      title: "Vehicle Type",
      dataIndex: "VEHTYPE",
      key: "VEHTYPE",
      render: (text) => {
        if (!text || !vehicleType?.length) return "-";

        const data = vehicleType.find((val) => val?.ID === text);

        return data?.NAME || "-";
      },
    },
    {
      title: "Status",
      dataIndex: "ACTIVE",
      key: "ACTIVE",
      render: (Status) => (
        <>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {Status === true ? (
              <>
                <Active style={{ width: "14px", height: "14px" }} />{" "}
                {/* Active icon */}
                <span style={{ fontSize: "16px" }}>Active</span>
              </>
            ) : (
              <>
                <span style={{ fontSize: "16px", color: "red" }}>Inactive</span>
              </>
            )}
          </div>
        </>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => {
        const removeTags = stripHtml(
          normalizeEditorValue(record?.MESSAGE || ""),
        );

        return (
          <div className="d-flex gap-3">
            <Switch
              disabled={!createAllowed}
              className="px-2"
              checked={record?.ACTIVE}
              onChange={(checked, e) => {
                e.stopPropagation();
                handleToogle(record?.KPIID);
              }}
            />
            <Tooltip title={!updateAllowed ? "No permission" : ""}>
              <img
                src={edit}
                alt="Edit Icon"
                onClick={(e) => {
                  if (!updateAllowed) return;
                  e.stopPropagation();
                  setIsEdit(true);

                  const editData = {
                    kpiname: record?.NAME,
                    eventtype: record?.EVTYPE,
                    Minuteslessthan: record?.MINMINUTES,
                    Minutesexceed: record?.MAXMINUTES,
                    Action: record?.ACTION,
                    recipiententitytype: record?.RECPTYPE?.replace(/^,/, "")
                      .split(",")
                      .map(
                        (code) =>
                          ({
                            C: "Consignor",
                            S: "Transporter",
                            Co: "Receiver",
                          })[code] || code,
                      )
                      .join(", "),
                    Additionalrecipient: record?.RECPLIST,
                    // message:
                    //   record?.MESSAGE?.replace(/<[^>]*>/g, "")
                    //     .replace(/@\w+/g, (match) => match)
                    //     ?.replace(/&nbsp;/g, "")
                    //     ?.replace(/<[^>]*>&lt;/g, "<")
                    //     ?.replace(/<[^>]*>&gt;/g, ">") || "",

                    message:
                      record?.MESSAGE?.replace(/&lt;/g, "<")
                        ?.replace(/&gt;/g, ">")
                        ?.replace(/&nbsp;/g, " ")
                        ?.replace(/<br\s*\/?>/gi, "\n")
                        ?.replace(/<[^>]*>/g, "") || "",
                    CRON: record?.CRON,
                    CRBY: record?.CRBY,
                    MCID: record?.MCID,
                    Vehicletype: record?.VEHTYPE,
                    InfoOnly: record?.ISINFO,
                    Autorepeated: record?.AUTOREP,
                    KPIID: record?.KPIID,
                    ACTIVE: record?.ACTIVE,
                    ModuleType: record?.ModuleType,
                  };

                  setFormData(editData);
                  // Set form values immediately after setting formData
                  form.setFieldsValue(editData);
                  setDrawyeropen(true);
                }}
                style={{
                  width: 22,
                  height: 22,
                  cursor: updateAllowed ? "pointer" : "not-allowed",
                  marginLeft: "10px",
                }}
              />
            </Tooltip>
            <Tooltip title={!deleteAllowed ? "No permission" : ""}>
              <img
                src={deleteicon}
                alt="Delete Icon"
                style={{
                  width: 22,
                  height: 22,
                  cursor: deleteAllowed ? "pointer" : "not-allowed",
                  marginLeft: "10px",
                }}
                onClick={(e) => {
                  if (!deleteAllowed) return;
                  e.stopPropagation();
                  setDeleteId(record?.KPIID);
                  setIsDeleteModalVisible(true);
                }}
              />
            </Tooltip>
          </div>
        );
      },
    },
  ];

  const [isEdit, setIsEdit] = useState(false);

  function normalizeEditorValue(v) {
    if (v == null) return "";
    if (typeof v !== "string") return String(v);

    const s = v.trim();

    // Some editors return a JSON-stringified HTML string, e.g.
    // "\"<p>Hello</p>\\n<p>World</p>\\n\""
    // Normalize it back to a plain HTML string before stripping tags.
    if (
      (s.startsWith('"') && s.endsWith('"')) ||
      (s.startsWith("'") && s.endsWith("'"))
    ) {
      try {
        return JSON.parse(s);
      } catch {
        // ignore and fall through
      }
    }

    return s;
  }

  function stripHtml(html) {
    const tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  }

  const handleSubmitForm = async (values) => {
    try {
      setLoading(true);
      const payload = {
        NAME: values?.kpiname,
        EVTYPE: values?.eventtype,
        MINMINUTES: values?.Minuteslessthan,
        MAXMINUTES: values?.Minutesexceed,
        ACTION: values?.Action,
        RECPTYPE: values?.recipiententitytype,
        RECPLIST: values?.Additionalrecipient.replace(/\n/g, ",") || "",
        MESSAGE:
          values?.Action === 0
            ? stripHtml(normalizeEditorValue(values?.message))
            : values?.message || "",
        ACTIVE: true,
        CRON: new Date(),
        CRBY: userInfo?.UID,
        MCID: userInfo?.MCID,
        VEHTYPE: values?.Vehicletype,
        VEHNAME: vehicleType?.find((val) => val?.ID === values?.Vehicletype)
          ?.NAME,
        ISINFO: values?.InfoOnly,
        AUTOREP: values?.Autorepeated,
        ModuleType: values?.ModuleType,
      };

      const updatepayload = {
        KPIID: formData?.KPIID,
        NAME: values?.kpiname,
        EVTYPE: values?.eventtype,
        MINMINUTES: values?.Minuteslessthan || "-",
        MAXMINUTES: values?.Minutesexceed,
        ACTION: values?.Action,
        RECPTYPE: values?.recipiententitytype,
        RECPLIST: values?.Additionalrecipient,
        MESSAGE:
          values?.Action === 0
            ? stripHtml(normalizeEditorValue(values?.message))
            : values?.message || "",
        ACTIVE: formData?.ACTIVE,
        CRON: formData?.CRON,
        CRBY: formData?.CRBY,
        MCID: userInfo?.MCID,
        VEHTYPE: values?.Vehicletype,
        VEHNAME:
          vehicleType?.find((val) => val?.ID === values?.Vehicletype)?.NAME ||
          "-",
        ISINFO: values?.InfoOnly,
        AUTOREP: values?.Autorepeated,
        ModuleType: formData?.ModuleType,
      };
      const { data } = await CALL_API(
        isEdit ? "PATCH" : "POST",
        isEdit ? "kpi/update" : `kpi/insert`,
        isEdit ? updatepayload : payload,
      );
      message.success(
        isEdit ? "KPI updated successfully " : "KPI created successfully",
      );
      handleCancel();
      fetchKpiData();
      setLoading(false);
    } catch (error) {
      console.error("[handleSubmitForm] error -->", error);
    }
  };

  const handleDelete = async (id) => {
    setLoading(true);
    const { data } = await CALL_API("DELETE", `kpi/deletekpi`, {
      KPIID: id,
    });
    fetchKpiData();
    message.success("Data Deleted Successfully");
  };

  const handleToogle = async (id) => {
    setLoading(true);
    const { data } = await CALL_API("GET", `kpi/togglestatus?kpiId=${id}`);
    fetchKpiData();
    message.success("Updated Successfully");
  };

  // const handleChange = (e) => {
  //   const { value, name } = e.target;
  //   setFormData((prevValue) => ({ ...prevValue, [name]: value }));
  // };
  const handleChange = (e, nameOverride) => {
    if (typeof e === "string") {
      if (!nameOverride) return; // Prevent updating with undefined key
      setFormData((prevValue) => ({ ...prevValue, [nameOverride]: e }));
      return;
    }
    const { value, name } = e.target;
    setFormData((prevValue) => ({ ...prevValue, [name]: value }));
  };

  const recipientOptions = (() => {
    const action = Number(formData?.Action); // Force to number

    if (Array.isArray(respientList)) {
      if (action === 0) {
        const uniqueUserIds = new Set();
        return respientList
          .filter((item) => {
            const uid = item?.USERID?.trim(); // Trim and check
            if (!uid || uniqueUserIds.has(uid)) return false;
            uniqueUserIds.add(uid);
            return true;
          })
          .map((item) => ({
            label: item.USERID,
            value: item.USERID,
          }));
      } else if (action === 1) {
        const uniqueEmails = new Set();
        return respientList
          .filter((item) => {
            const email = item?.EMAIL?.trim(); // Trim and check
            if (!email || uniqueEmails.has(email)) return false;
            uniqueEmails.add(email);
            return true;
          })
          .map((item) => ({
            label: item.EMAIL,
            value: item.EMAIL,
          }));
      }
    }
    return [];
  })();

  const modulelabel = [
    { ID: 1, name: "Track Right AI", value: 1 },
    { ID: 2, name: "Track Right AI +", value: 2 },
    { ID: 3, name: "Track Right AI Cargo", value: 3 },
    { ID: 4, name: "Nexus - TrackRight AI", value: 4 },
  ];

  const AddEditForm = {
    pages: [
      {
        fields: [
          [
            {
              id: "kpiname",
              label: (
                <p
                  style={{
                    fontFamily: "Inter",
                    fontWeight: 400,
                    fontStyle: "normal", // instead of "Regular"
                    fontSize: "20px", // you can override 14px
                    lineHeight: "100%",
                    letterSpacing: "0",
                  }}
                >
                  KPI Name
                </p>
              ),

              type: "text",
              name: "kpiname",
              validationRules: [
                { required: true, message: "KPI Name is required" },
              ],
            },
            {
              id: "Eventtype",
              label: (
                <p
                  style={{
                    fontFamily: "Inter",
                    fontWeight: 400,
                    fontStyle: "normal", // instead of "Regular"
                    fontSize: "20px", // you can override 14px
                    lineHeight: "100%",
                    letterSpacing: "0",
                  }}
                >
                  Event Type
                </p>
              ),
              type: "selectwithvalue",
              name: "eventtype",
              options: RTypeEnum.map((item, index) => ({
                label: item?.name || item?.label,
                value: item?.value,
              })),
              validationRules: [
                { required: true, message: "Event Type is required" },
              ],
            },

            {
              id: "Action",
              label: (
                <p
                  style={{
                    fontFamily: "Inter",
                    fontWeight: 400,
                    fontStyle: "normal", // instead of "Regular"
                    fontSize: "20px", // you can override 14px
                    lineHeight: "100%",
                    letterSpacing: "0",
                  }}
                >
                  Action
                </p>
              ),
              type: "selectwithvalue",
              name: "Action",
              options: ActiontypeEnum?.map((item) => ({
                label: item?.name,
                value: item?.value,
              })),
              validationRules: [
                { required: true, message: "Action Type is required" },
              ],
            },
            {
              id: "recipiententitytype",
              label: (
                <p
                  style={{
                    fontFamily: "Inter",
                    fontWeight: 400,
                    fontStyle: "normal", // instead of "Regular"
                    fontSize: "20px", // you can override 14px
                    lineHeight: "100%",
                    letterSpacing: "0",
                  }}
                >
                  Recipient Entity Type
                </p>
              ),

              type: "selectwithvalue",
              name: "recipiententitytype",
              options: Reciepenttype?.filter((item) => item.value !== "").map(
                (item) => ({
                  label: item?.name,
                  value: item?.value,
                }),
              ),
              mode: "multiple",
              validationRules: [
                {
                  required: true,
                  message: "Recipient Entity type is required",
                },
              ],
            },
          ],
          [
            {
              id: 4,
              label: (
                <p
                  style={{
                    fontFamily: "Inter",
                    fontWeight: 400,
                    fontStyle: "normal", // instead of "Regular"
                    fontSize: "20px", // you can override 14px
                    lineHeight: "100%",
                    letterSpacing: "0",
                  }}
                >
                  Additional Recipient
                </p>
              ),
              type: "textareaMultipleEmail",
              name: "Additionalrecipient",
              options: recipientOptions,
            },
            {
              id: "Minuteslessthan",
              label: (
                <p
                  style={{
                    fontFamily: "Inter",
                    fontWeight: 400,
                    fontStyle: "normal", // instead of "Regular"
                    fontSize: "20px", // you can override 14px
                    lineHeight: "100%",
                    letterSpacing: "0",
                  }}
                >
                  Minutes Less than{" "}
                </p>
              ),

              type: "text",
              name: "Minuteslessthan",
              validationRules: [
                { required: false, message: "Minutes Less than is required" },
              ],
            },
            {
              id: "Minutes Exceed",
              label: (
                <p
                  style={{
                    fontFamily: "Inter",
                    fontWeight: 400,
                    fontStyle: "normal", // instead of "Regular"
                    fontSize: "20px", // you can override 14px
                    lineHeight: "100%",
                    letterSpacing: "0",
                  }}
                >
                  {" "}
                  Minutes Exceed
                </p>
              ),
              type: "text",
              name: "Minutesexceed",
              validationRules: [
                { required: true, message: "Minutes Exceed is required" },
              ],
            },
            {
              id: "Vehicle Type",
              label: (
                <p
                  style={{
                    fontFamily: "Inter",
                    fontWeight: 400,
                    fontStyle: "normal", // instead of "Regular"
                    fontSize: "20px", // you can override 14px
                    lineHeight: "100%",
                    letterSpacing: "0",
                  }}
                >
                  {" "}
                  Vehicle Type
                </p>
              ),
              type: "selectwithvalue",
              name: (
                <p
                  style={{
                    fontFamily: "Inter",
                    fontWeight: 400,
                    fontStyle: "normal", // instead of "Regular"
                    fontSize: "20px", // you can override 14px
                    lineHeight: "100%",
                    letterSpacing: "0",
                  }}
                >
                  {" "}
                  Vehicletype
                </p>
              ),
              required: true,
              options: vehicleType?.map((item) => ({
                value: item.ID,
                label: item.NAME,
              })),
              validationRules: [
                { required: false, message: "Vehicle Type is required" },
              ],
            },
          ],
          [
            {
              id: "Module",
              label: (
                <p
                  style={{
                    fontFamily: "Inter",
                    fontWeight: 400,
                    fontStyle: "normal", // instead of "Regular"
                    fontSize: "20px", // you can override 14px
                    lineHeight: "100%",
                    letterSpacing: "0",
                  }}
                >
                  Module
                </p>
              ),
              type: "selectwithvalueandcheckbox",
              name: "ModuleType",
              mode: "multiple",
              value: formData?.ModuleType,
              options: modulelabel.map((item, index) => ({
                label: item?.name || item?.label,
                value: item?.value,
              })),
              validationRules: [
                { required: true, message: "Module is required" },
              ],
            },

            {
              id: "infoOnly?",
              label: (
                <p
                  style={{
                    fontFamily: "Inter",
                    fontWeight: 400,
                    fontStyle: "normal", // instead of "Regular"
                    fontSize: "20px", // you can override 14px
                    lineHeight: "100%",
                    letterSpacing: "0",
                  }}
                >
                  Info Only?
                </p>
              ),
              type: "switch",
              name: "InfoOnly",
              // validationRules: [
              //   { required: true, message: "Info Only type is required" },
              // ],
            },

            {
              id: "Auto Repeated?",
              label: (
                <p
                  style={{
                    fontFamily: "Inter",
                    fontWeight: 400,
                    fontStyle: "normal", // instead of "Regular"
                    fontSize: "20px", // you can override 14px
                    lineHeight: "100%",
                    letterSpacing: "0",
                  }}
                >
                  Auto Repeated?
                </p>
              ),
              type: "switch",
              name: "Autorepeated",
              // validationRules: [
              //   { required: true, message: "Auto Repeated type is required" },
              // ],
            },
            {},
          ],
          ...(formData?.Action === 1 || formData?.Action === 0
            ? [
                [
                  // {
                  //   id: 6, // Unique ID
                  //   label: formData?.Action === 1
                  //     ? "Message (Type @ for Tags)" // Label for Action 1 (Email)
                  //     : "Message", // Label for Action 0 (SMS)
                  //   type: formData?.Action === 1 ? "editor" : "text", // Use "text" for Action 0 (SMS) and "editor" for Action 1 (Email)
                  //   name: "message",
                  //   placeholder: "Enter your message",
                  //   // render: () => (
                  //   //   <MinimalExample
                  //   //     value={formData.message}
                  //   //     onChange={(value) => setFormData((prevData) => ({ ...prevData, message: value }))}
                  //   //     customTags={CustomTagsEnum} // Pass the array directly
                  //   //   />
                  //   // ),
                  //   validationRules: [
                  //     {
                  //       required: true,
                  //       message: "Please enter your Message Details",
                  //     },
                  //   ],
                  // },
                  {
                    id: 6,
                    label:
                      formData?.Action === 1
                        ? "Message (Type @ for Tags)"
                        : "Message",
                    type:
                      formData?.Action === 1 ? "editorWithMentions" : "text",
                    name: "message",
                    placeholder: "Enter your message",
                    validationRules: [
                      {
                        required: true,
                        message: "Please enter your Message Details",
                      },
                    ],
                  },
                ],
              ]
            : []),
        ],
        colSpan: [6],
      },
    ],
  };
  useEffect(() => {
    fetchKpiData();
  }, [pageSize, currentPage, filterValues]);
  const getFilterCount = () => {
    const count = Object.values(filterValues).filter(
      (val) => val !== undefined && val !== null && String(val).trim() !== "",
    ).length;

    setFilterCount(count);
  };

  useEffect(() => {
    getFilterCount();
  }, [filterValues]);

  return (
    <>
      {isView ? (
        <KpiCustfied
          setStateforpage={setStateforpage}
          stateforpage={stateforpage}
          setIsView={setIsView}
          handleToogle={handleToogle}
        />
      ) : (
        <>
          <Newbox>
            <Row gutter={16}>
              <Col xs={{ span: 24, order: 2 }} xl={24}>
                <div className="container_for_kpi mt-4">
                  <p>{total} KPIs</p>
                  <div className="container_for_kp">
                    {/* <Select
                      className="select_icon_dropdown"
                      showSearch
                      style={{
                        width: 290,
                      }}
                      // placeholder={
                      //   <Input
                      //     style={{
                      //       width: "150px",
                      //       border: "none",
                      //       outline: "none",
                      //     }}
                      //     prefix={<SearchOutlined className="search_icon" />}
                      //   />
                      // }
                      suffixIcon={null}
                    ></Select> */}

                    <Badge
                      onClick={showModal}
                      className="badge_customiztion"
                      count={filterCount}
                    >
                      <Avatar
                        shape="square"
                        icon={<FilterOutlined className="search_icon" />}
                      />
                    </Badge>
                    <Modal
                      open={filterModalOpen}
                      onCancel={() => setFilterModalOpen(false)}
                      width={900}
                      footer={
                        <ButtonFilled
                          onClick={() => {
                            setFilterValues({
                              actiontype: "",
                              eventtype: "",
                            });
                            filterform.setFieldsValue({
                              actiontype: "",
                              eventtype: "",
                            });
                          }}
                        >
                          {" "}
                          Clear All{" "}
                        </ButtonFilled>
                      }
                    >
                      <Row>
                        <Col xl={24} xs={{ span: 24, order: 2 }}>
                          <div className="container_for_kpi_filter">
                            <h6 className="Filter_for_clickablerow">
                              Filter ({filterCount})
                            </h6>
                            {/* <p className="Filter_for_Result">4 Result Found </p> */}
                          </div>
                        </Col>
                      </Row>
                      <Form
                        form={filterform}
                        layout="vertical"
                        onValuesChange={(value, allvalues) => {
                          setFilterValues(allvalues);
                        }}
                        initialValues={filterValues}
                      >
                        <Row gutter={16}>
                          <Col xs={24} sm={24} md={6}>
                            <Form.Item label="KPI Name" name="name">
                              <Input placeholder="" className="rounded-pill" />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={6}>
                            <Form.Item label="Action Type" name="actiontype">
                              <Select
                                className="w-100"
                                allowClear={true}
                                showSearch
                                suffixIcon={null}
                                optionFilterProp="label"
                                filterOption={(input, option) =>
                                  option?.label
                                    ?.toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                              >
                                {ActiontypeEnum.map((item) => (
                                  <Option
                                    key={item.value}
                                    value={item.value}
                                    label={item.name}
                                  >
                                    {item.name}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={24} md={6}>
                            <Form.Item label="Event Type" name="eventtype">
                              <Select
                                className="w-100"
                                allowClear
                                showSearch
                                placeholder=""
                                suffixIcon={null}
                                optionFilterProp="label"
                                filterOption={(input, option) =>
                                  option?.label
                                    ?.toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                              >
                                {RTypeEnum.map((item) => (
                                  <Select.Option
                                    key={item.value}
                                    value={item.value}
                                    label={item.name}
                                  >
                                    {item.name}
                                  </Select.Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                        </Row>
                      </Form>
                    </Modal>
                    <Tooltip title={!createAllowed ? "No permission" : ""}>
                      <Button
                        disabled={!createAllowed}
                        onClick={() => {
                          setIsEdit(false);
                          const emptyData = {
                            kpiname: "",
                            eventtype: "",
                            Action: "",
                            recipiententitytype: "",
                            Additionalrecipient: "",
                            Minuteslessthan: "",
                            Minutesexceed: "",
                            Vehicletype: "",
                            InfoOnly: false,
                            Autorepeated: false,
                            ModuleType: "",
                            message: "",
                          };
                          setFormData(emptyData);
                          form.resetFields(); // This should work now
                          setDrawyeropen(true);
                        }}
                        className="and_clear_btn"
                        type="primary"
                      >
                        + Create
                      </Button>
                    </Tooltip>
                  </div>
                </div>
              </Col>
            </Row>
          </Newbox>

          <Newbox>
            <Row gutter={16}>
              <Col xl={24}>
                <Spin spinning={loading}>
                  {kpiData?.length > 0 && (
                    <StyledTable
                      className="table_forkpi_page"
                      dataSource={kpiData}
                      onRow={(record) => ({
                        onClick: (e) => {
                          e.stopPropagation();
                          handleRowClick(record);
                        },
                        onMouseEnter: () => setHoveredIcon(record.key),
                        onMouseLeave: () => setHoveredIcon(null),
                      })}
                      pagination={false}
                      columns={columns}
                    />
                  )}
                  <ReusablePagination
                    pageSize={pageSize}
                    handlePageSizeChange={handlePageSizeChange}
                    currentPage={currentPage}
                    total={total}
                    handlePageChange={handlePageChange}
                  />
                </Spin>
              </Col>
            </Row>
          </Newbox>

          <ReusableDrawer
            title={""}
            open={Drawyeropen}
            setOpen={setDrawyeropen}
            closable={false}
            className="custom-drawer"
            footer={[
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  gap: "15px",
                }}
              >
                <Button
                  key="cancel"
                  className="cancel-btn"
                  onClick={handleCancel}
                  style={{
                    borderRadius: "26px",
                    backgroundColor: "#E8FFEC",
                    color: "#2C963D",
                    borderColor: "#E8FFEC",
                    width: "118px",
                    height: "38px",
                  }}
                >
                  Cancel
                </Button>
                <ButtonFilled onClick={() => form.submit()}>
                  {isEdit ? "Update" : "Create"}
                </ButtonFilled>
              </div>,
            ]}
          >
            <Newbox>
              <Row>
                <Col sm={24} xl={24}>
                  <div className="popup_container_for_forms">
                    <p className="modifying_kpi">
                      {isEdit ? "Modifying KPI" : "Creating KPI"}
                    </p>
                    <div>
                      <CloseOutlined
                        onClick={handleCancel}
                        style={{ cursor: "pointer", fontSize: "20px" }}
                      />
                    </div>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col sm={24} xl={24}>
                  <hr />
                </Col>
              </Row>
              <GridBuilder
                formStructureJson={AddEditForm}
                handleChange={handleChange}
                formSubmit={handleSubmitForm}
                initialValues={formData}
                form={form}
                handleSelectChange={handleSelectChange}
              />
            </Newbox>
          </ReusableDrawer>
          <UIModal
            width={500}
            open={isDeleteModalVisible}
            onClose={() => {
              setIsDeleteModalVisible(false);
              setDeleteId(null); // Reset the delete ID
            }}
            closeButton={false}
            size="md"
            header={false}
            footer={false}
          >
            <div className="text-center">
              <h1>Are you sure,</h1>
              <h6>You want to delete this KPI?</h6>
              <div className="mt-2 w-100 d-flex justify-content-center">
                <ButtonFilled
                  onClick={() => {
                    handleDelete(deleteId); // Call the delete function with the selected ID
                    setIsDeleteModalVisible(false); // Close the modal
                    setDeleteId(null); // Reset the delete ID
                  }}
                >
                  Yes
                </ButtonFilled>
                <Buttontransparent
                  onClick={() => {
                    setIsDeleteModalVisible(false); // Close the modal
                    setDeleteId(null); // Reset the delete ID
                  }}
                >
                  No
                </Buttontransparent>
              </div>
            </div>
          </UIModal>
        </>
      )}
    </>
  );
};

export default Kpimaster;

// const MessageField = ({ value, onChange, customTags }) => {
//   const tagList = customTags.map((tag) => ({
//     id: tag.value,
//     value: tag.label,
//   }));

//   return (
//     <ReactQuill
//       value={value}
//       onChange={onChange}
//       modules={{
//         toolbar: [
//           [{ header: [1, 2, false] }],
//           ["bold", "italic", "underline", "strike"],
//           ["link"],
//         ],
//         mention: {
//           allowedChars: /^[A-Za-z_]*$/,
//           mentionDenotationChars: ["@"],
//           source: function (searchTerm, renderList) {
//             if (searchTerm.length === 0) {
//               renderList(tagList, searchTerm);
//             } else {
//               const matches = tagList.filter((tag) =>
//                 tag.value.toLowerCase().includes(searchTerm.toLowerCase())
//               );
//               renderList(matches, searchTerm);
//             }
//           },
//         },
//       }}
//       placeholder="Type your message here..."
//     />
//   );
// };

// const MinimalExample = () => {
//   const tagList = [
//     { id: "CONSIGNID", value: "CODE" },
//     { id: "TRIPID", value: "TRIPCODE" },
//   ];

//   return (
//     <ReactQuill
//       modules={{
//         mention: {
//           allowedChars: /^[A-Za-z_]*$/,
//           mentionDenotationChars: ["@"],
//           source: function (searchTerm, renderList) {
//             if (searchTerm.length === 0) {
//               renderList(tagList, searchTerm);
//             } else {
//               const matches = tagList.filter((tag) =>
//                 tag.value.toLowerCase().includes(searchTerm.toLowerCase())
//               );
//               renderList(matches, searchTerm);
//             }
//           },
//         },
//       }}
//       placeholder="Type @ to see options..."
//     />
//   );
// };
